import Dropzone_onBoardingStatic from 'assets/images/Dropzone_Static_2x.png';
import classNames from 'classnames';
import { Button } from 'components/atoms/Button';
import type { dropzoneMeta } from 'components/molecules/Dropzone/Dropzone.types';
import type { fileUploaderMeta } from 'components/organisms/FileUploader/FileUploader.types';
import { get } from 'lodash';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { maxFileSize } from 'utils/constants';

const getDropzoneMsg = (
  dropzoneMeta: dropzoneMeta,
  fileUploaderMeta: fileUploaderMeta,
) => {
  if (fileUploaderMeta.done) return 'Drag & drop any document';
  if (dropzoneMeta.isDragActive) return 'Drag & drop any document';
  return 'Drag & drop any document';
};

export const DropzoneContent: FC<{
  dropzoneMeta: dropzoneMeta;
  fileUploaderMeta: fileUploaderMeta;
  imgProps?: Record<string, any>;
  aiHighlight?: boolean;
}> = (props) => {
  const { dropzoneMeta, fileUploaderMeta, imgProps } = props;

  const { t } = useTranslation();

  const showFileSizeWarning = get(dropzoneMeta, 'fileRejections')?.some(
    (rejection: any) => rejection.file.size > maxFileSize,
  );

  return (
    <div className="pb-12 w-full flex flex-col items-center">
      <img
        alt=""
        width="288px"
        height="288px"
        src={Dropzone_onBoardingStatic}
        {...imgProps}
        className={classNames('w-[18rem] h-[18rem]', imgProps?.className)}
      />
      <p
        className={
          props.aiHighlight
            ? 'relative font-degular !capitalize font-bold text-2xl lg:text-3xl flex gap-2 !bg-clip-text ai-gradient'
            : 'mb-1 text-xl lg:text-2xl text-primary-700 font-avenir font-semibold text-center'
        }
      >
        {t('repository.dropzone.title')}
      </p>
      <span className="text-primary hover:text-primary-800 font-semibold text-center">
        {t('repository.dropzone.subtitle')}
      </span>
      {showFileSizeWarning && (
        <span className="bg-yellow-100 text-sm mt-2 px-1">
          {t('warning_file_to_big')}
        </span>
      )}
    </div>
  );
};

export const FilesListHeader: FC<{ fileUploaderMeta: fileUploaderMeta }> = (
  props,
) => {
  const { fileUploaderMeta } = props;

  const { t } = useTranslation();

  if (!fileUploaderMeta.done) return null;

  return (
    <div className="pb-5">
      <p className="text-primary-900 text-base font-assistant">
        {t('repository.dropzone.success_msg')}
      </p>
    </div>
  );
};

export const FilesListFooter: FC<{
  fileUploaderMeta: fileUploaderMeta;
  onViewDocument?: (fileUploaderMeta: fileUploaderMeta) => void;
}> = (props) => {
  const { t } = useTranslation();
  const { fileUploaderMeta, onViewDocument } = props;
  const { done } = fileUploaderMeta;

  return (
    <div className="flex gap-2 py-5 justify-end">
      <Button
        disabled={!done}
        onClick={() => onViewDocument?.(fileUploaderMeta)}
      >
        {t('repository.dropzone.view_cta')}
      </Button>
    </div>
  );
};
